<form [formGroup]="updatePasswordForm">
  <div class="">
    <div class="lg:flex justify-between mb-6">
      <div class="">
        <div class="text-1xl font-bold">Mot de passe</div>
        <div class="text-sm">Vous pouvez modifier votre passe ici.</div>
      </div>
    </div>
    <hr class="h-px bg-gray-300 border-0 dark:bg-gray-700" />
    <div class="grid lg:grid-cols-3 gap-2 my-6 mx-0" style="display: grid;">
      <div class="mb-1 font-semibold text-sm">Mot de passe actuel</div>
      <div class="col-span-2">
        <input
          formControlName="actuelPassword"
          type="password"
          placeholder="*********"
          value=""
          id="first_name"
          class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 h-15"
          required
          [style.border]="isSuccess == true ? '3px solid #1fd319' : ''"
        />
      </div>
    </div>
    <!-- <hr class="h-px bg-gray-300 border-0 dark:bg-gray-700">
    <div class="grid lg:grid-cols-3 gap-6 my-6">
      <div class="label">
            Mot de passe actuel
      </div>
      <div class="col-span-2">
          <input type="password" placeholder="*********" value="" id="first_name" class="bg-white border border-gray-500 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 h-15"  required>
      </div>
    </div> -->
    <div class="grid lg:grid-cols-3 gap-2 my-6 mx-0" style="display: grid;">
      <div class="mb-1 font-semibold text-sm">Nouveau mot de passe</div>
      <div class="col-span-2">
        <input
          formControlName="newPassword"
          type="password"
          placeholder="*********"
          value=""
          id="first_name"
          class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 h-15"
          required
          [style.border]="isPasswordMismatch == true ? '3px solid #EB4045' : ''"
          [style.border]="isSuccess == true ? '3px solid #1fd319' : ''"
        />
      </div>
    </div>
    <div class="grid lg:grid-cols-3 gap-2 my-6 mx-0" style="display: grid;">
      <div class="mb-1 font-semibold text-sm">Confirmer le nouveau mot de passe</div>
      <div class="col-span-2">
        <input
          formControlName="confirmNewPassword"
          type="password"
          placeholder="*********"
          value=""
          id="first_name"
          class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 h-15"
          required
          [style.border]="isPasswordMismatch == true ? '3px solid #EB4045' : ''"
          [style.border]="isSuccess == true ? '3px solid #1fd319' : ''"
        />
      </div>
    </div>
    <div *ngIf="isSuccess" style="color: #1fd319" class="justify-center">
      <p>Le mot de passe a été changé avec succes!</p>
    </div>
    <div *ngIf="isServerError" style="color: #eb4045" class="justify-center">
      <p>Erreur du serveur!</p>
    </div>
    <div *ngIf="isnotValid" style="color: #eb4045" class="justify-center">
      <p>Le mot de passe actuel saisi est erroné!</p>
    </div>
    <div
      *ngIf="isPasswordMismatch"
      style="color: #eb4045"
      class="justify-center"
    >
      <p>Vous avez saisi des mots de passe differents!</p>
    </div>
    <div class="flex justify-end mt-6">
      <div class="mt-4">
        <button
          type="button"
          class="border border-gray-300 transition hover:bg-gray-100 font-semibold rounded-lg text-sm px-5 py-2.5 me-2 mb-2"
        >
          Annuler
        </button>
        <button
          type="button"
          class="text-white btn-login transition text-sm px-5 py-2.5 me-2 mb-2 bg-blue font-semibold rounded-lg"
          (click)="onSubmitForm()"
        >
          Changer mot de passe
        </button>
      </div>
    </div>
  </div>
</form>
